import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ViewController, NavParams, Events } from 'ionic-angular';

// Providers
import { RecertificationService } from '../../providers/instructors/recertification-service';

// Helpers
import { HelperService } from '../../providers/helpers/helper-service';

@Component({
  templateUrl: 'instructor-payment.modal.html',
  providers: [DatePipe]
})

export class InstructorPaymentModalPage
{
  recertification: any = {};
  payment: any = {};
  formErrors: any = {};

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public recertificationService: RecertificationService,
    public events: Events,
    public helperService: HelperService,
    public datePipe: DatePipe
  ) {
    this.viewCtrl = viewCtrl;
    this.recertification = this.navParams.get('recertification');
  }

  saveEntry()
  {
    this.recertification.amount_charged = +this.payment.amount;
    this.recertification.pay_by = this.payment.pay_by;

    this.recertificationService.saveRecertification( this.recertification )
      .subscribe( data => {
        this.events.publish('app:log', {
          message: 'Instructor re-certification payment has been saved.',
          status: 'success',
          type: 'save instructor payment'
        });

        if ( this.payment.pay_by === 'credit_card' )
        {
          this.showEnterCreditCardInfoPage();
        }

        this.events.publish('recertification:refresh');
        this.dismissModal();
      },
      error => {
        this.helperService.showErrors( error );
      }      
    );
  }

  showEnterCreditCardInfoPage()
  {
    let recertification = this.recertification;
    let payment = this.payment;

    // Format URI to send to WOU payment processing system.
    let dateString = this.helperService.getDateToday().replace(/-/g, '').substring( 2 );
    let paymentIndex = payment.index_code;
    let ss_id = paymentIndex + dateString + '01';

    let query_string = 'ID=' + encodeURIComponent(ss_id) + '&FIRST_NAME=' + encodeURIComponent(recertification.first_name) + '&LAST_NAME=' + encodeURIComponent(recertification.last_name) + '&PRODUCT_DESC=' + encodeURIComponent('Driving Instructor Recertification') + '&AMOUNT_CHARGED=' + encodeURIComponent(payment.amount) + '&CUSTOMER_ORGANIZATION=' + encodeURIComponent('Intentionally blank') + '&ADDITIONAL_INFORMATION=' + encodeURIComponent('Intentionally blank');
    let cc_url = 'https://www2.wou.edu/nora/business.cc_payment.p_traffic_safety_education?' + query_string;

    // Open the payment screen in a new tab.
    window.open(cc_url);
  }

  dismissModal() {
    this.viewCtrl.dismiss();
  }
}


// WEBPACK FOOTER //
// ./src/components/modals/instructor-payment.modal.ts